module.exports = __webpack_public_path__ + "static/Kreuzung_Hubertstrasse_Luisenstrasse-e944b04825ed9ca115e2ed8c369e6d67.JPG";